(()=>{
  const ignored='script,style,noscript,textarea,option,svg,sup,template,.metavro-brand,a[href^="mailto:"],a[href^="tel:"],[contenteditable]';
  function trademark(root){
    if(!root)return;
    const nodes=[];
    if(root.nodeType===3)nodes.push(root);
    else if(root.nodeType===1&&!root.closest(ignored)){
      const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
      while(walker.nextNode())nodes.push(walker.currentNode);
    }
    nodes.forEach(node=>{
      if(!node.parentElement||node.parentElement.closest(ignored))return;
      const text=node.nodeValue;
      const pattern=/\bMetavro\b(?![\w@-]|\.[a-z])/gi;
      const matches=[...text.matchAll(pattern)].filter(m=>!/(?:@|https?:\/\/)[^\s]*$/i.test(text.slice(0,m.index))&&!/^(?:™|®|\s*TM\b)/.test(text.slice(m.index+m[0].length)));
      if(!matches.length)return;
      const fragment=document.createDocumentFragment();let last=0;
      matches.forEach(m=>{
        fragment.append(document.createTextNode(text.slice(last,m.index)));
        const brand=document.createElement('span');brand.className='metavro-brand';brand.append(document.createTextNode(m[0]));
        const mark=document.createElement('sup');mark.className='metavro-tm';mark.setAttribute('aria-label','trademark');mark.textContent='TM';brand.append(mark);fragment.append(brand);last=m.index+m[0].length;
      });
      fragment.append(document.createTextNode(text.slice(last)));node.replaceWith(fragment);
    });
  }
  function menu(root=document){
    root.querySelectorAll('[data-menu]').forEach(button=>{
      if(button.dataset.bound)return;button.dataset.bound='1';
      const nav=document.getElementById(button.getAttribute('aria-controls'));if(!nav)return;
      const close=()=>{button.setAttribute('aria-expanded','false');nav.classList.remove('is-open');};
      button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open);});
      nav.addEventListener('click',event=>{if(event.target.closest('a'))close();});
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&button.getAttribute('aria-expanded')==='true'){close();button.focus();}});
      document.addEventListener('click',event=>{if(!nav.contains(event.target)&&!button.contains(event.target))close();});
      matchMedia('(min-width:1051px)').addEventListener('change',close);
    });
    root.querySelectorAll('nav a[href]').forEach(link=>{if(new URL(link.href,location.origin).pathname===location.pathname)link.setAttribute('aria-current','page');});
  }
  function ready(){
    document.documentElement.classList.remove('no-js');menu();trademark(document.body);
    const observer=new MutationObserver(records=>{
      observer.disconnect();
      try{records.forEach(record=>{if(record.type==='characterData')trademark(record.target);else record.addedNodes.forEach(trademark);});}
      finally{observer.observe(document.body,{subtree:true,childList:true,characterData:true});}
    });
    observer.observe(document.body,{subtree:true,childList:true,characterData:true});
    document.addEventListener('shopify:section:load',event=>{menu(event.target);trademark(event.target);});
    const status=document.querySelector('[data-form-status]');if(status)status.focus();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
